import cx from 'classnames';
import styles from './styles.module.scss';
import { useEffect, useMemo, useState } from 'react';
import { USER_PROFILE_PLACEHOLDER } from '../../../constants/assetConstants';
import { icons } from '../../../assets';
import { DropdownMenu } from '../../subscriptionComponents/DropdownMenu';
import { useUserContext } from '../../../contexts/UserContext';
import InfiniteScroll from '../../../components/InfiniteScroll/InfiniteScroll';
import { MODE, useApiList } from '../../../hooks/useApiList';
import { ElipsisTooltip } from '../../../common/ElipsisTooltip';
import {
  WHO_CAN_ACCESS_PAGE_LABEL,
  WHO_CAN_ACCESS_PAGE,
  PRODUCT_PAGE_SHARE_ACCESS,
  PRODUCT_PAGE_SHARE_ACCESS_LABEL,
} from './index';
import { apiGetSharedMemberList, apiRemoveSharedMemberAccess, apiUpdateWhoCanAccessTypeValue, updateSharedMemberAccess } from '../../../helpers/api';
import { isTextureProductPage, openFormInCaseOfNewOrgAndFreemiumUser, removeUndefinedText } from '../../../helpers/jsHelper';
import { selectPublicLinkData, setSharePublicLinkData } from '../../../redux/slicers/productV2Slicer';
import { useDispatch, useSelector } from 'react-redux';
import { successToastV2 } from '../../../helpers/toastHelper';
import { selectTotalEditors, selectUsedEditors } from '../../../redux/slicers/subscriptionSlicer';
import InfoDialogUI from '../../../components/InfoDialog/InfoDialogUI';
import { WarningContentInfoIcon } from '../../../assets/icons';
import { BigButton } from '../../../common';
import { PopoverMenu } from '../../subscriptionComponents/DropdownMenuPopover';
const { ArrowIconV2, TickIcon, LockIcon } = icons;

export const WhoHaveAccess = ({ product, className = '' }) => {
  const dispatch = useDispatch();
  const { currentUser } = useUserContext();
  const publicLinkData = useSelector(selectPublicLinkData);
  const usedEditors = useSelector(selectUsedEditors);
  const totalEditors = useSelector(selectTotalEditors);
  const [whoCanAccess, setWhoCanAccess] = useState(WHO_CAN_ACCESS_PAGE.INVITED);
  const [noEditorAccess, setNoEditorAccess] = useState(false);
  const availableEditor = +totalEditors - +usedEditors

  useEffect(() => {
      +publicLinkData?.product_page_share_access && setWhoCanAccess(+publicLinkData?.product_page_share_access || WHO_CAN_ACCESS_PAGE.INVITED)
  }, [publicLinkData?.unique_code]);

  const handleUpdateWhoCanAccessType = async (type) => {
    if(whoCanAccess === type) return
    if(publicLinkData?.id){
      const payload = {
        product_page_share_access:+type
      }
     const res = await apiUpdateWhoCanAccessTypeValue({id:publicLinkData?.mainId , data:payload})
     if(res?.id){
      dispatch(setSharePublicLinkData(res || {}))
      setWhoCanAccess(type)
     }
    }
  }
  

  const whoCanAccessList = useMemo(
    () => [
      {
        id: 1,
        title: (
          <>
            <TickIcon style={{ opacity: whoCanAccess === WHO_CAN_ACCESS_PAGE.INVITED ? 1 : 0 }} />{' '}
            <span>{WHO_CAN_ACCESS_PAGE_LABEL[WHO_CAN_ACCESS_PAGE.INVITED]}</span>
          </>
        ),
        onClick: (v) => handleUpdateWhoCanAccessType(WHO_CAN_ACCESS_PAGE.INVITED),
      },
      {
        id: 2,
        title: (
          <>
            <TickIcon style={{ opacity: whoCanAccess === WHO_CAN_ACCESS_PAGE.ANYONE ? 1 : 0 }} />{' '}
            <span>{WHO_CAN_ACCESS_PAGE_LABEL[WHO_CAN_ACCESS_PAGE.ANYONE]}</span>
          </>
        ),
        onClick: (v) => handleUpdateWhoCanAccessType(WHO_CAN_ACCESS_PAGE.ANYONE),
      },
    ],
    [whoCanAccess, currentUser]
  );

  const WhoCanAccessLabel = useMemo(
    () => (
      <div className={styles.menuLabel}>
        <div className="d-flex align-items-center gap-2">
          <LockIcon />
          <span>
            {WHO_CAN_ACCESS_PAGE_LABEL[whoCanAccess]?.replace(
              'ORGANIZATION_NAME',
              currentUser?.organization_detail?.name
            )}
          </span>
        </div>
        <ArrowIconV2 className={styles.arrowIcon} />
      </div>
    ),
    [whoCanAccess, currentUser]
  );

  const params = useMemo(() => {
    return {
      params: {
        search: '',
        [isTextureProductPage() ? "texture" : "product"]:product?.id
      },
    };
  }, [product]);

  const { loading, hasMore, refetch, total, fetchNextPage, list } = useApiList({
    api: apiGetSharedMemberList,
    mode: MODE.PARAMS,
    defaultPerPage: 20,
    params,
    // dataFormatter: (d) => dataFormatter(d, category),
  });

  const onAccessChange = async ({ access = null, memberId = null , item = null }) => { 
    if (!access || !memberId) return;
    if(+access === +item?.permission_type) return null
    if(access === PRODUCT_PAGE_SHARE_ACCESS.REMOVE){
      const res = await apiRemoveSharedMemberAccess(memberId)
      if(res && res.status){
        successToastV2(res?.message || "Deleted successfully.")
        refetch()
      }
    }else{
      if(!availableEditor > 0 && access === PRODUCT_PAGE_SHARE_ACCESS.CAN_EDIT){
        setNoEditorAccess(item)
        return null
      }
      const payload = {
        permission_type:access
      }
      const res = await updateSharedMemberAccess({id:memberId , data:payload})
      if(res){
        refetch()
      }
    }
  };

  return (
    <div className={cx(styles.container, className)}>
      <h2 className={styles.heading}>WHO HAVE ACCESS</h2>
      <NoEditorAvailable product={product} noEditorAccess={noEditorAccess} setNoEditorAccess={setNoEditorAccess}/>
      <DropdownMenu
        className={cx('m-0 w-100', styles.menu, styles.whoCanAccess)}
        menu={whoCanAccessList}
        button={WhoCanAccessLabel}
      />
      {list?.length > 0 ? (
        <div className={styles.membersList}>
          <InfiniteScroll
            loadingType={null}
            dataLength={list.length}
            next={fetchNextPage}
            hasMore={hasMore}
            loading={loading}
            hasChildren={Boolean(list.length)}
            scrollableTarget="infiniteScroll">
            {list.map((item) => (
              <MemberCard
                key={item.id}
                {...item}
                availableEditor={availableEditor}
                onAccessChange={(access) =>
                  onAccessChange({
                    access,
                    memberId: item?.id,
                    item:item
                  })
                }
              />
            ))}
          </InfiniteScroll>
        </div>
      ) : null}
    </div>
  );
};

const MemberCard = ({
  id,
  member_name,
  member_email,
  member_profile,
  member_first_name,
  member_last_name,
  share_to_email,
  role,
  isSignup = true,
  onAccessChange,
  permission_type = null,
  availableEditor = 0,
  ...rest
}) => {
  const { currentUser } = useUserContext();
  const [imageLoadErrorId, setImageLoadErrorId] = useState(false);
  const [access, setAccess] = useState(+permission_type || PRODUCT_PAGE_SHARE_ACCESS.CAN_VIEW);

  const name =  removeUndefinedText(member_name) || `${removeUndefinedText(member_first_name)} ${removeUndefinedText(member_last_name)}`?.trim() || removeUndefinedText(rest?.member_organization) || removeUndefinedText(rest?.share_to_organization_name)
  const email = removeUndefinedText(share_to_email) || removeUndefinedText(member_email)

  const menuList = useMemo(
    () => [
      {
        id: 1,
        title: (
          <>
            <TickIcon style={{ opacity: access === PRODUCT_PAGE_SHARE_ACCESS.CAN_VIEW ? 1 : 0 }} />{' '}
            <span>{PRODUCT_PAGE_SHARE_ACCESS_LABEL[PRODUCT_PAGE_SHARE_ACCESS.CAN_VIEW]}</span>
          </>
        ),
        onClick: (v) => {
          setAccess(PRODUCT_PAGE_SHARE_ACCESS.CAN_VIEW);
          onAccessChange(PRODUCT_PAGE_SHARE_ACCESS.CAN_VIEW);
        },
      },
      {
        id: 2,
        title: (
          <>
            <TickIcon style={{ opacity: access === PRODUCT_PAGE_SHARE_ACCESS.CAN_EDIT ? 1 : 0 }} />{' '}
            <span>{PRODUCT_PAGE_SHARE_ACCESS_LABEL[PRODUCT_PAGE_SHARE_ACCESS.CAN_EDIT]}</span>
          </>
        ),
        onClick: (v) => {
          if(availableEditor > 0){
            setAccess(PRODUCT_PAGE_SHARE_ACCESS.CAN_EDIT);
          }
          onAccessChange(PRODUCT_PAGE_SHARE_ACCESS.CAN_EDIT);
        },
      },
      {
        id: 3,
        title: (
          <>
            <TickIcon style={{ opacity: access === PRODUCT_PAGE_SHARE_ACCESS.REMOVE ? 1 : 0 }} />{' '}
            <span>{PRODUCT_PAGE_SHARE_ACCESS_LABEL[PRODUCT_PAGE_SHARE_ACCESS.REMOVE]}</span>
          </>
        ),
        onClick: (v) => {
          setAccess(PRODUCT_PAGE_SHARE_ACCESS.REMOVE);
          onAccessChange(PRODUCT_PAGE_SHARE_ACCESS.REMOVE);
        },
        separate: true,
      },
    ],
    [access, permission_type]
  );

  const AccessLabel = useMemo(
    () => (
      <div className={styles.menuLabel}>
        <span>{PRODUCT_PAGE_SHARE_ACCESS_LABEL[access]}</span>
        <ArrowIconV2 />
      </div>
    ),
    [access, permission_type]
  );

  return (
    <div id={id} className={styles.member}>
      <div className={styles.details}>
        <div className={styles.profile}>
          {member_profile ? (
            <img
              src={!imageLoadErrorId ? member_profile : USER_PROFILE_PLACEHOLDER}
              onError={(e) => setImageLoadErrorId(true)}
            />
          ) : (
            <div className={cx(styles.noProfile, isSignup ? styles.signup : '')}></div>
          )}
        </div>

        <div className={styles.info}>
          <ElipsisTooltip title={name?.trim()}>
            {({ ref, onMouseEnter, onMouseLeave }) => (
              <h2
                className={styles.name}
                ref={ref}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}>
                {name?.trim()}
                {email?.trim() === currentUser?.user?.email ? ` (you)` : ''}
              </h2>
            )}
          </ElipsisTooltip>
          <ElipsisTooltip title={email?.trim()}>
            {({ ref, onMouseEnter, onMouseLeave }) => (
              <h5
                className={styles.email}
                ref={ref}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}>
                {email?.trim()}
              </h5>
            )}
          </ElipsisTooltip>
        </div>
      </div>

      <div className={styles.action}>
        <PopoverMenu
          key={id}
          className={cx('m-0', styles.menu)}
          menu={menuList}
          button={AccessLabel}
        />
      </div>
    </div>
  );
};

const NoEditorAvailable = (props) => {
  const handleUpdatePlan  = () => {
    openFormInCaseOfNewOrgAndFreemiumUser();
    return
  }
  const email = props?.noEditorAccess?.member_email || props?.noEditorAccess?.share_to_email || props?.noEditorAccess?.share_to_organization_name
  return <InfoDialogUI
  size="lg"
  show={props?.noEditorAccess}
  closeable={false}
  onClose={()=> props?.setNoEditorAccess(false)}
  bodyClassName={styles.root}
  backdropClassName={styles.inviteModal}
  animation={true}>
  <div className={styles.wrapper}>
  <div className={styles.successContainer}>
      <p><WarningContentInfoIcon /></p>
      <h2>Invite alert!</h2>
      <div className={styles.subDescription}>
        <p>
          {`${email} couldn’t be invited to edit the `}<strong>{props?.product?.name}</strong>{` as you do not have enough editors on your plan.`}
        </p>
      </div>
      <div className={styles.actionButtonContainer}>
        <BigButton
          className={`keep-text ${styles.okayBtn}`}
          onClick={() => handleUpdatePlan()}
          disabled={false}
          buttonTitle="Upgrade Plan"
        />
      </div>
    </div>
  </div>
</InfoDialogUI>
}
